import { useEffect, useState } from 'react'
import type { GrowthCategory } from '@mc/api'
import {
  Button,
  Dropdown,
  DropdownToggle,
  IconArrowLeftDefault,
  IconChevronRightDefault,
} from '@mc/design-system'
import {
  GreaterThanOrEqual,
  LessThan,
} from 'components/Navigation/consumer/components/Media'
import { MobileDropdown } from 'components/Navigation/consumer/components/MobileDropdown'
import {
  btnClasses,
  categoryHoverSmartPreload,
  SubcategoriesDropdownContent,
} from 'components/Navigation/consumer/components/SubcategoryBrowse/SubcategoryBrowse'
import { trackMainCategoryClicked } from 'components/Navigation/consumer/events'

export const CategoryButton = ({
  category,
  order,
  currentCategory,
}: {
  category: GrowthCategory
  order: number
  currentCategory: GrowthCategory | null
}) => {
  const isCurrentCategory = currentCategory?.id === category.id
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (isCurrentCategory) {
      setShow(true)
    }
  }, [isCurrentCategory])

  const breakpoint = 'lg'

  const categoryBtn = (
    <div className='d-flex'>
      <Button
        kind='tertiary'
        fullWidth
        className={btnClasses(show)}
        onClick={() => {
          trackMainCategoryClicked({
            id: String(category.id),
            categoryName: category.name,
            order,
          })
          setShow((prev) => !prev)
        }}
        onMouseEnter={(e: React.MouseEvent) =>
          categoryHoverSmartPreload(e, category.id)
        }
      >
        <span className='flex-grow-1'>{category.name}</span>
        <IconChevronRightDefault size='md' />
      </Button>
    </div>
  )

  return (
    <>
      <LessThan bp={breakpoint}>
        {categoryBtn}
        {show && (
          <MobileDropdown>
            <div className='mc-px-3 mc-mt-3'>
              <Button
                rounded
                kind='secondary'
                className='mc-mx-2'
                onClick={() => setShow(false)}
              >
                <IconArrowLeftDefault />
              </Button>
              <h6 className='mc-mt-3 mc-ml-3 mc-text-h6'>{category.name}</h6>
            </div>
            <SubcategoriesDropdownContent
              show={show}
              setShow={setShow}
              category={category}
            />
          </MobileDropdown>
        )}
      </LessThan>
      <GreaterThanOrEqual bp={breakpoint}>
        <Dropdown placement='right'>
          <DropdownToggle>{categoryBtn}</DropdownToggle>
          {show ? (
            <SubcategoriesDropdownContent
              show={show}
              setShow={setShow}
              category={category}
            />
          ) : (
            <></>
          )}
        </Dropdown>
      </GreaterThanOrEqual>
    </>
  )
}
